<template>
  <div>
    <VCard
      class="mb-6"
      title="Olá lojista, seja bem-vindo ao admin do  Gift Delivery🚀"
    >
      <VCardText>Acompanhe de perto o desempenho do seu negócio</VCardText>
      <VCardText>
        <p>Este é um espaço onde você poderá acompanhar de perto o desempenho do seu negócio, com informações atualizadas e precisas sobre as vendas realizadas e os resultados obtidos.</p>
        Saiba mais <a
          href="https://codifytech.com.br/"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none"
        >
          Desenvolvido por CodifyTech
        </a> Acesso a gráfico de vendas e dashboard
      </VCardText>
    </VCard>

    <VCard title="Suas informações estão segura 🔒">
      <VCardText>Dados criptografados.</VCardText>
      <VCardText>Aumente suas vendas com o APLICATIVO Gift Delivery.</VCardText>
    </VCard>
  </div>
</template>

<route lang="yaml">
meta:
  action: read
  subject: Auth
</route>
